/**
 * Core-100 R2 — CORE-Z: which parking spots Create Ticket may offer. Occupancy is PHYSICAL truth
 * (`vehicle_location_current`, the same occupancy the move authority checks under its lock —
 * not the legacy `tickets.parking_spot_id` columns), re-read whenever the picker opens. A failed
 * occupancy read offers NOTHING rather than every spot: an unknown is not "free".
 * The offer is advisory; the database (`vlc_spot_exclusive`) is the guarantee.
 */
export interface SpotOption { id: string; label: string; spot_type: string }

export function availableSpotsFrom(
  spots: SpotOption[],
  occupied: Map<string, string> | null,
): SpotOption[] {
  if (!occupied) return [];
  return spots
    .filter((s) => !occupied.has(s.id))
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
}

/**
 * Core-100 R4 — CORE-Z: the Check-In dialog's spot list from the SAME physical occupancy (`vehicle_location_current`
 * via readShopOccupiedSpotIds) — it used the legacy `tickets.parking_spot_id` columns and ignored a failed read, so
 * an unreadable occupancy offered every spot as free. `occupied === null` (unknown) marks every spot unavailable:
 * unknown is not free. The ticket being checked in never blocks its own spot.
 */
export interface CheckInSpotOption extends SpotOption { occupied: boolean }

export function checkInSpotOptions(
  spots: SpotOption[],
  occupied: Map<string, string> | null,
  ticketId: string,
): { spots: CheckInSpotOption[]; occupancyKnown: boolean } {
  const occupancyKnown = occupied !== null;
  return {
    occupancyKnown,
    spots: spots
      .map((s) => {
        const holder = occupied?.get(s.id);
        return { ...s, occupied: !occupancyKnown || (holder !== undefined && holder !== ticketId) };
      })
      .sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })),
  };
}
